<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="users"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-text-field
          v-model="search"
          label="Search"
          class="mx-4"
        ></v-text-field>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn color="blue darken-1" small @click="editItem(item)">Edit</v-btn>
        <v-btn color="red darken-1" small @click="deleteItem(item)">Delete</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Role', value: 'role' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      users: [
        { name: 'Alice', email: 'alice@example.com', role: 'Admin' },
        { name: 'Bob', email: 'bob@example.com', role: 'User' },
        { name: 'Charlie', email: 'charlie@example.com', role: 'Editor' }
      ]
    };
  },
  methods: {
    editItem(item) {
      console.log('Edit', item);
    },
    deleteItem(item) {
      console.log('Delete', item);
    }
  }
};
</script>
